export let localStorageCart = [];

export function setLocalStorageCart(){
    if (localStorage.getItem('cart')){
        localStorageCart = JSON.parse(localStorage.getItem('cart'));
    }
    return localStorageCart;
}
export function isItemExistsInCart(id, addons){
    setLocalStorageCart();
    if (localStorageCart?.length){
        for (const item of localStorageCart) {
            if (item.id === id && JSON.stringify(item.attributes)===JSON.stringify(addons)) return true;
        }
    }
    return false;
}
export function getQuantity(id, addons={}){
    setLocalStorageCart();
    if (localStorageCart?.length){
        for (const item of localStorageCart) {
            if (item.id === id && JSON.stringify(item.attributes)===JSON.stringify(addons)) {
                return item.quantity;
            }
        }
    }
    return 0;
}

export const addToCart = (product, quantity=1) => {
    setLocalStorageCart();
    if (localStorageCart){
        if (isItemExistsInCart(product.id, product?.chosenAddons, localStorageCart)){
            localStorageCart.forEach(item => {
                if (item.id === product.id && JSON.stringify(item.attributes)===JSON.stringify(product?.chosenAddons)) {
                    item.quantity+=quantity;
                    item.itemTotal+=(quantity*item.price);
                    item.taxPrice+=(quantity*(product.tax));
                }
            })
            localStorage.setItem('cart', JSON.stringify(localStorageCart))
        }else{
            localStorage.setItem('cart', JSON.stringify([
                ...localStorageCart, 
                { 
                    product, 
                    id: product.id, 
                    quantity: quantity, 
                    price: product.priceWithAddons || product.price,
                    itemTotal: (product.priceWithAddons || product.price)*quantity,
                    taxPrice: product.tax,
                    attributes: product?.chosenAddons,
                },
            ]));
        }
    }else{
        localStorage.setItem('cart', JSON.stringify([
            ...localStorageCart,
            { product, id: product.id, quantity: 1, price: product.price }
        ]));
    }
}

export const subtractItem = (product) => {
    setLocalStorageCart();
    if (getQuantity(product.id, (product?.chosenAddons || product?.productAddons))>1){
        localStorageCart.forEach(item => {
            if (item.id === product.id && JSON.stringify(item.attributes)===JSON.stringify(product?.chosenAddons || product?.productAddons)) {
                item.taxPrice-=product?.tax;
                item.itemTotal-=item.price;
                item.quantity--;
            }
        })
        localStorage.setItem('cart', JSON.stringify(localStorageCart))
    }else{
        let i;
        for (i = 0; i < localStorageCart.length; i++) {
            if (localStorageCart[i].id === product.id) {
                localStorageCart.splice(i, 1);
                break;
            }
        }
        localStorage.setItem('cart', JSON.stringify(localStorageCart));
    }
}

export const deleteSubtractItem = (product) => {
    let i;
    for (i = 0; i < localStorageCart.length; i++) {
        if (localStorageCart[i].id === product.id) {
            localStorageCart.splice(i, 1);
            break;
        }
    }
    localStorage.setItem('cart', JSON.stringify(localStorageCart));
}

export const  updateItemInCart=(cartItem, quantity=1, chosenAddons)=>{
    setLocalStorageCart();
    localStorageCart.forEach(item => {
        if (item.id === cartItem?.id && JSON.stringify(item.attributes)===JSON.stringify(cartItem?.attributes)) {
            item.quantity = quantity;
            item.itemTotal = (quantity*item.price);
            item.taxPrice = (quantity*cartItem?.product?.tax);
            item.attributes = [...chosenAddons];
            item.product = {...cartItem.product, productAddons: chosenAddons}
        }
    })
    localStorage.removeItem('cart')
    localStorage.setItem('cart', JSON.stringify(localStorageCart))
}

export const clearLocalStorgeCart = () => {
    if (localStorage.getItem('cart')){
        localStorage.removeItem('cart');
        localStorageCart = [];
    }
    return localStorageCart;
}